import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
    addEvents();
    loadCourses();
}

function addEvents() {
    $(document).on("dblclick", "#tblSiteCourses tbody tr", viewCourse);
}

//
//Event handlers
//
function viewCourse() {
    const courseId = $(this).closest("tr").data("courseid");
    window.location.href = application.baseUrl + "/course/index/" + courseId;
}
//
// Functions
//
function loadCourses() {
    //const container = $("#divSiteCoursesTable");
    //const siteId = $("#siteCourseSiteId").val();
    //const params = {
    //    url:
    //        "/api/Site/GetCoursesBySiteId/" + siteId
    //};
    //dataaccess.post(params).done(function(results) {
    //    container.html(results);
    //    $("#tblSiteCourses").DataTable();
    //});
}

export const siteCourses = {
    init: init
};
